import { render, staticRenderFns } from "./OpenImportButton.vue?vue&type=template&id=5df95f32&scoped=true"
import script from "./OpenImportButton.vue?vue&type=script&lang=ts"
export * from "./OpenImportButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df95f32",
  null
  
)

export default component.exports